// extracted by mini-css-extract-plugin
export default {"purchaseModal":"NotificatorModal_purchaseModal__++yxK","btnWrapper":"NotificatorModal_btnWrapper__3TcJR"};